import Vue from 'vue'
import VueRouter from 'vue-router'
import EcommerceHome from '../views/Home.vue'
// import EcommerceProductDetail from '../views/ProductDetail.vue'
// import EcommerceCart from '../views/Cart.vue'
// import EcommerceCheckout from '../views/Checkout.vue'

Vue.use(VueRouter)

const ecommerceRoutes = [
  {
    path: '/e-commerce-web',
    name: 'EcommerceHome',
    component: EcommerceHome
  },
  // {
  //   path: '/e-commerce-web/product/:id',
  //   name: 'EcommerceProductDetail',
  //   component: EcommerceProductDetail,
  //   props: true
  // },
  // {
  //   path: '/e-commerce-web/cart',
  //   name: 'EcommerceCart',
  //   component: EcommerceCart
  // },
  // {
  //   path: '/e-commerce-web/checkout',
  //   name: 'EcommerceCheckout',
  //   component: EcommerceCheckout,
  //   meta: { requiresAuth: true }
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: ecommerceRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router